import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';
import { CpsConfirmDialogState } from '@cs-cms/types';

interface IConfirmDialogProps {
  title?: string;
  message: string;
  onConfirm: (confirmed: CpsConfirmDialogState) => void;
  confirmButtonOnly?: boolean;
  className?: string;
}

export const ConfirmDialog: React.FC<IConfirmDialogProps> = props => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <Dialog className={props.className || ''} title={props.title} onClose={() => props.onConfirm('dismiss')}>
      <p>{props.message}</p>
      <DialogActionsBar>
        {props.confirmButtonOnly ? (
          <Button
            themeColor="primary"
            title={translate('custom.common.confirm')}
            onClick={() => props.onConfirm('yes')}
          >
            {translate('custom.common.confirm')}
          </Button>
        ) : (
          <>
            <Button themeColor="primary" title={translate('custom.common.yes')} onClick={() => props.onConfirm('yes')}>
              {translate('custom.common.yes')}
            </Button>
            <Button themeColor="secondary" title={translate('custom.common.no')} onClick={() => props.onConfirm('no')}>
              {translate('custom.common.no')}
            </Button>
          </>
        )}
      </DialogActionsBar>
    </Dialog>
  );
};
